import type { FaqSurface } from "./types";

export type HelpFaqRouteBucket = "default" | "buy" | "sell";

/**
 * Coarse Help route bucket from pathname (D11).
 * Few buckets — not every URL.
 */
export function resolveHelpFaqRouteBucket(
  pathname: string,
): HelpFaqRouteBucket {
  const path = pathname || "/";
  if (
    path.startsWith("/sell") ||
    path.startsWith("/my-items") ||
    path.startsWith("/my-stuff/selling") ||
    path.startsWith("/edit-item")
  ) {
    return "sell";
  }
  if (
    path.startsWith("/item/") ||
    path.startsWith("/my-purchases") ||
    path.startsWith("/my-stuff/buying") ||
    path.startsWith("/my-stuff/looking") ||
    path.startsWith("/checkout") ||
    path.startsWith("/transactions") ||
    path.startsWith("/orders")
  ) {
    return "buy";
  }
  return "default";
}

/** Surface preset for Help FAB sheet from pathname. */
export function resolveHelpFaqSurface(pathname: string): FaqSurface {
  const bucket = resolveHelpFaqRouteBucket(pathname);
  if (bucket === "buy") return "help_fab_buy";
  if (bucket === "sell") return "help_fab_sell";
  return "help_fab";
}
